import React from "react";
import Joi from "joi-browser";
import ip from "ip";
import { toast } from "react-toastify";
import { Form, Button, Modal, Spinner } from "react-bootstrap";
import { addIpV4Pool } from "../services/ipv4PoolService";
import { Paper } from "@material-ui/core";
import FormComponent from "./common/formComponent";
import { formatNumber } from "../services/util";
import PageLoading from "./common/pageLoading";

class AddIpV4Pool extends FormComponent {
  state = {
    data: {
      name: "",
      network: "",
      cidr: "",
      subnetMask: "",
      hostCount: "",
      type: "",
      class: "",
    },
    errors: {},
    calculatedNetwork: {},
    showCalculateModal: false,
    loading: true,
    processing: false,
  };

  schema = {
    name: Joi.string().required().label("Name"),
    network: Joi.string().required().label("Network"),
    cidr: Joi.number().min(16).required().label("CIDR"),
    subnetMask: Joi.string().required().label("Subnet Mask"),
    hostCount: Joi.number().min(1).required().label("Number of Hosts"),
    type: Joi.string().required().label("Type"),
    class: Joi.string().required().label("Class"),
  };

  doSubmit = async () => {
    this.setState({ processing: true });
    const { data } = this.state;

    try {
      await addIpV4Pool(data);

      this.props.history.push("/ipv4pools");
      toast.success("IP Pool Added");
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }
    this.setState({ processing: false });
  };

  async componentDidMount() {
    this.setState({ loading: false });
  }

  handleShowCalculateModal = () => {
    const data = { ...this.state.data };
    const calculatedNetwork = this.calculateNetwork(data.network, data.cidr);

    data.hostCount = calculatedNetwork.numHosts;
    data.subnetMask = calculatedNetwork.subnetMask;

    this.setState({ data, calculatedNetwork, showCalculateModal: true });
  };

  handleClose = () => {
    this.setState({ showCalculateModal: false });
  };

  calculateNetwork(network, cidr) {
    return ip.cidrSubnet(network + "/" + cidr);
  }

  render() {
    const { data, calculatedNetwork, errors, showCalculateModal, loading, processing } = this.state;

    return (
      <Paper elevation={3}>
        <Form onSubmit={this.handleSubmit}>
          <div className="card">
            <div className="card-header main-color-bg">
              <div className="row">
                <div className="col-md">
                  <h5>Add IpV4 Pool</h5>
                </div>
                <div className="col-md"></div>
              </div>
            </div>
            <div className="card-body">
              {loading && <PageLoading loading={loading} />}
              {!loading && (
                <React.Fragment>
                  <Form.Group controlId="name">
                    <Form.Label>Name</Form.Label>
                    <Form.Control
                      name="name"
                      onChange={this.handleChange}
                      value={data.name}
                      size="sm"
                      type="text"
                      autoFocus
                    />
                    {errors.name && <span className="text-danger">{errors.name}</span>}
                  </Form.Group>

                  <Form.Group controlId="network">
                    <Form.Label>Network</Form.Label>
                    <Form.Control
                      name="network"
                      onChange={this.handleChange}
                      value={data.network}
                      size="sm"
                      type="text"
                    />
                    {errors.network && <span className="text-danger">{errors.network}</span>}
                  </Form.Group>

                  <Form.Group controlId="cidr">
                    <Form.Label>CIDR</Form.Label>
                    <Form.Control name="cidr" onChange={this.handleChange} value={data.cidr} size="sm" type="text" />
                    {errors.cidr && <span className="text-danger">{errors.cidr}</span>}
                  </Form.Group>

                  <Form.Group controlId="type">
                    <Form.Label>Type</Form.Label>
                    <Form.Control as="select" name="type" value={data.type} onChange={this.handleChange}>
                      <option></option>
                      <option>main</option>
                      <option>subnet</option>
                    </Form.Control>
                    {errors.type && <span className="text-danger">{errors.type}</span>}
                  </Form.Group>

                  <Form.Group controlId="class">
                    <Form.Label>Type</Form.Label>
                    <Form.Control as="select" name="class" value={data.class} onChange={this.handleChange}>
                      <option></option>
                      <option>private</option>
                      <option>public</option>
                    </Form.Control>
                    {errors.type && <span className="text-danger">{errors.class}</span>}
                  </Form.Group>
                </React.Fragment>
              )}

              {!loading && (
                <Button
                  type="button"
                  variant="warning"
                  className="mr-3"
                  onClick={() => this.handleShowCalculateModal()}
                >
                  Calculate
                </Button>
              )}
            </div>
          </div>

          <Modal show={showCalculateModal} size="md" centered onHide={this.handleClose}>
            <Modal.Header closeButton>
              <Modal.Title>Calculate Network</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              Network Address: {calculatedNetwork.networkAddress} <br />
              CIDR: {calculatedNetwork.subnetMaskLength} <br />
              First Address: {calculatedNetwork.firstAddress} <br />
              Last Address: {calculatedNetwork.lastAddress} <br />
              Broadcast Address: {calculatedNetwork.broadcastAddress} <br />
              Sunbet Mask: {calculatedNetwork.subnetMask} <br />
              Hosts: {formatNumber(calculatedNetwork.numHosts, "currency", "")} <br />
            </Modal.Body>

            <Modal.Footer>
              <Button onClick={this.handleClose} variant="secondary">
                Cancel
              </Button>
              <Button
                
                onClick={() => this.doSubmit()}
                type="submit"
                variant="primary"
              >
                {processing && (
                  <Spinner as="span" className="mr-2" animation="border" size="sm" role="status" aria-hidden="true" />
                )}
                Add IP Pool
              </Button>
            </Modal.Footer>
          </Modal>
        </Form>
      </Paper>
    );
  }
}

export default AddIpV4Pool;
